import axios from '../../axios';
import { useQuery } from '@tanstack/react-query';
import type { TFeedSpaceItem, TError } from '@onesource/schemas';
import { ENTITY } from '../entity';

/**
 * Query key for fetching feed spaces - non-hook version
 */
export const getFeedSpacesQueryKey = () => [ENTITY, 'feed-spaces'];

/**
 * Query key for fetching feed spaces
 */
export const useGetFeedSpacesQueryKey = () => getFeedSpacesQueryKey();

/**
 * Hook to fetch all feed-type spaces with access info
 * Used for sidebar Community menu to show feed spaces with locked state
 *
 * @returns List of feed spaces with hasAccess flag
 */
export const useGetFeedSpaces = () => {
  return useQuery<TFeedSpaceItem[], TError>({
    queryKey: useGetFeedSpacesQueryKey(),
    queryFn: async () => {
      const res = await axios.get<TFeedSpaceItem[]>('/community-hub/feed-spaces');
      return res.data;
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};
